import React from "react";

const STEPS = [
  {
    title: "Submit Your Project",
    desc: "Indie filmmakers, publishers and other creators pitch films, magazines or other projects.",
    badge: null,
    color: "#f20d0e",
  },
  {
    title: "Community DAO Votes",
    desc: "GEOCHIC's community DAO reviews submissions and votes on which projects get funded.",
    badge: "DAO VOTE · ON-CHAIN",
    color: "#2d2d2d",
  },
  {
    title: "GEOCHIC Co-Funds It",
    desc: "GEOCHIC invests 5–50% as lead investor, and the community co-funds the rest on-chain.",
    badge: "ON-CHAIN",
    color: "#c8930a",
  },
  {
    title: "Get Fractional Ownership",
    desc: "Supporters receive Fractional Ownership, becoming verified co-owners on-chain.",
    badge: "ON-CHAIN",
    color: "#2d2d2d",
  },
  {
    title: "Share in the Success",
    desc: "Co-owners share in the project's success and vote to reward future projects.",
    badge: "ON-CHAIN",
    color: "#f20d0e",
  },
];

const HowItWorks = () => (
  <section className="hiw_section">
    <div className="hiw_header">
      <h2 className="hiw_heading">How It Works</h2>
    </div>

    <div className="hiw_flow">
      {STEPS.map((step, i) => (
        <article
          key={i}
          className={[
            "hiw_card",
            i === 0 ? "hiw_card--first" : "",
            i === STEPS.length - 1 ? "hiw_card--last" : "",
          ].join(" ")}
          style={{ "--color": step.color, "--idx": STEPS.length - i }}
        >
          <div className="hiw_card_inner">
            <h4 className="hiw_title">{step.title}</h4>
            <p className="hiw_desc">{step.desc}</p>
            {step.badge && <span className="hiw_badge">{step.badge}</span>}
          </div>
        </article>
      ))}
    </div>

    {/* Mobile step connectors */}
    <style>{`
      @media (max-width: 991px) {
        .hiw_card + .hiw_card { margin-top: 10px; }
      }
    `}</style>
  </section>
);

export default HowItWorks;
